import styled from "styled-components";

export const Container = styled.div`
  padding: 92px 43px 0 75px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  align-items: center;
  margin-top: 43px;
  padding-bottom: 80px;
`;
